module.exports = __webpack_public_path__ + "static/media/1361_Message_popup.850f7f75.png";